import React from 'react'
import { Navigate } from 'react-router-dom'
import type { RouteObject } from 'react-router-dom'
import { AuthGuard } from '@/features/auth/components/AuthGuard'
import { AppLayout } from '@/features/layout/AppLayout'

const DashboardPage = React.lazy(() =>
  import('@/features/dashboard/pages/DashboardPage').then((m) => ({ default: m.DashboardPage }))
)
const AuthCallbackPage = React.lazy(() =>
  import('@/features/auth/pages/AuthCallbackPage').then((m) => ({ default: m.AuthCallbackPage }))
)
const UsersPage = React.lazy(() =>
  import('@/features/users/pages/UsersPage').then((m) => ({ default: m.UsersPage }))
)
const TaxProfilesPage = React.lazy(() =>
  import('@/features/tax-profiles/pages/TaxProfilesPage').then((m) => ({ default: m.TaxProfilesPage }))
)
const PayoutsPage = React.lazy(() =>
  import('@/features/payouts/pages/PayoutsPage').then((m) => ({ default: m.PayoutsPage }))
)
const PaymentsPage = React.lazy(() =>
  import('@/features/payments/pages/PaymentsPage').then((m) => ({ default: m.PaymentsPage }))
)
const GiftCodesPage = React.lazy(() =>
  import('@/features/giftcodes/pages/GiftCodesPage').then((m) => ({ default: m.GiftCodesPage }))
)
const MilestonesConfigPage = React.lazy(() =>
  import('@/features/bonus/pages/MilestonesConfigPage').then((m) => ({ default: m.MilestonesConfigPage }))
)
const BanksConfigPage = React.lazy(() =>
  import('@/features/bank/pages/BanksConfigPage').then((m) => ({ default: m.BanksConfigPage }))
)
const SystemConfigPage = React.lazy(() =>
  import('@/features/config/pages/SystemConfigPage').then((m) => ({ default: m.SystemConfigPage }))
)

const SuspenseWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <React.Suspense
    fallback={
      <div className="flex items-center justify-center min-h-[50vh]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-500" />
      </div>
    }
  >
    {children}
  </React.Suspense>
)

export const routeDefinitions: RouteObject[] = [
  {
    path: '/',
    element: (
      <AuthGuard requireAdminAccess>
        <AppLayout />
      </AuthGuard>
    ),
    children: [
      { index: true, element: <SuspenseWrapper><DashboardPage /></SuspenseWrapper> },
      { path: 'users', element: <SuspenseWrapper><UsersPage /></SuspenseWrapper> },
      { path: 'tax-profiles', element: <SuspenseWrapper><TaxProfilesPage /></SuspenseWrapper> },
      { path: 'payouts', element: <SuspenseWrapper><PayoutsPage /></SuspenseWrapper> },
      { path: 'payments', element: <SuspenseWrapper><PaymentsPage /></SuspenseWrapper> },
      { path: 'gift-codes', element: <SuspenseWrapper><GiftCodesPage /></SuspenseWrapper> },
      { path: 'system-config', element: <SuspenseWrapper><SystemConfigPage /></SuspenseWrapper> },
    ],
  },
  {
    path: '/auth/callback',
    element: <SuspenseWrapper><AuthCallbackPage /></SuspenseWrapper>,
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]
